import { callFirebaseFunction } from './firebase';

// --- HELPER: SAFE FALLBACK SCORE ---
const getSafeFallbackScore = () => ({
  impactScore: 50, sourceAnalysis: { tier: 'none' },
  rhetoricalType: 'Theoretical', // Default
  logic: { score: 0.5, feedback: "Error." }, evidence: { score: 0.5, feedback: "Error." },
  civility: { score: 1.0, feedback: "Error." }, engagement: { score: 0.5, feedback: "Error." },
  overallFeedback: "AI unavailable."
});

// --- SOURCE QUALITY ANALYST ---
export const assessSourceQuality = async (argument, sourceUrl) => {
  try {
    const result = await callFirebaseFunction('assessSourceQuality', { argument, sourceUrl });
    return result;
  } catch (error) {
    console.error("Source assessment error:", error);
    return { tier: "none", relevance: 0 };
  }
};

// --- IMPACT SCORING & RHETORICAL ANALYSIS ---
export const scorePost = async (postBody, debateContext = {}) => {
  // --- REMOVED LOCAL SANITY CHECK ---
  // All inputs are now processed by the backend or fallback gracefully.
  
  try {
    const result = await callFirebaseFunction('scorePost', { 
        postBody, 
        debateContext 
    });
    return result;
  } catch (error) {
    console.error("AI Scoring Error:", error);
    return getSafeFallbackScore();
  }
};

// --- GENERATE AI RESPONSE ---
export const generateAiResponse = async (debateContext) => {
  try {
    const result = await callFirebaseFunction('generateAiResponse', { debateContext });
    return result;
  } catch (error) {
    console.error("AI Response Error:", error);
    return { text: " [AI] (System: I need a moment to think. Please try again shortly.)" };
  }
};

// --- COACHING DRILL ---
export const getAiSenseiDrill = async (weakness = null) => {
  try {
    const result = await callFirebaseFunction('getAiSenseiDrill', { weakness });
    return result;
  } catch (e) { 
    console.error("Drill generation error:", e);
    return { title: "Error", prompt: "Could not generate drill." }; 
  }
};

export const verifySource = async (sourceUrl, claim, sourceText = null) => {
    return assessSourceQuality(claim, sourceUrl); 
};

// --- ADJUDICATOR ---
export const declareWinner = async (debateHistory, topic) => {
  try {
    const result = await callFirebaseFunction('declareWinner', { debateHistory, topic });
    return result;
  } catch (e) { 
    console.error("Adjudication error:", e);
    return { winner: "Draw", scores: {}, verdict: "Error during adjudication." }; 
  }
};

// --- UTILITIES ---
export const curateNewTopics = async () => { 
    return { status: "error", message: "Deprecated in this view." }; 
};

export const getAISummary = async () => { 
    return "Summary disabled."; 
};